import type { UseQueryOptions, UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import type {
  GetPatientUsProviderGroupProfileArgs,
  GetPatientUsProviderGroupProfileResponse,
} from "api/types/GetPatientUsProviderGroupProfile";
import { useApiClient } from "api/useApiClient";

export type UseGetPatientUsProviderGroupProfileQueryArgs = GetPatientUsProviderGroupProfileArgs;

type QueryKey = ["useGetPatientUsProviderGroupProfileQuery", UseGetPatientUsProviderGroupProfileQueryArgs];

export const getPatientUsProviderGroupProfileQueryKey = (
  args: UseGetPatientUsProviderGroupProfileQueryArgs
): QueryKey => ["useGetPatientUsProviderGroupProfileQuery", args];

export const useGetPatientUsProviderGroupProfileQuery = (
  args: UseGetPatientUsProviderGroupProfileQueryArgs,
  options?: UseQueryOptions<
    GetPatientUsProviderGroupProfileResponse,
    Error,
    GetPatientUsProviderGroupProfileResponse,
    QueryKey
  >
): UseQueryResult<GetPatientUsProviderGroupProfileResponse, Error> => {
  const client = useApiClient();

  return useQuery(getPatientUsProviderGroupProfileQueryKey(args), () => client.getPatientUsProviderGroupProfile(args), {
    cacheTime: Infinity,
    staleTime: Infinity,
    ...options,
  });
};
